(function () {
  function inEmbeddedContext() {
    try {
      return window.top !== window.self;
    } catch (_error) {
      return true;
    }
  }

  function openFallback(url) {
    if (!url) return;

    if (inEmbeddedContext()) {
      const popup = window.open(url, "_blank", "noopener,noreferrer");
      if (popup) return;
    }

    window.location.assign(url);
  }

  function isVisible(node) {
    if (!(node instanceof HTMLElement)) return false;
    const style = window.getComputedStyle(node);
    if (style.display === "none" || style.visibility === "hidden") return false;
    return node.getClientRects().length > 0;
  }

  function getTextLaunchers(root) {
    return Array.from(document.querySelectorAll("button, a")).filter((node) => {
      if (!(node instanceof HTMLElement)) return false;
      if (root.contains(node)) return false;
      if (!isVisible(node)) return false;
      const text = (node.textContent || "").trim();
      return /(join program|refer|referral|share link|get my link|get referral link)/i.test(text);
    });
  }

  function getBloopLaunchers(root) {
    const selectors = [
      "[data-bloop-launcher]",
      "[data-bloop-popup]",
      "[data-bloop-referral]",
      "[data-bloop-widget]",
      "[class*='bloop-launch']",
      "[class*='bloop-widget'] button",
      "[id*='bloop-launch']",
      "button[class*='bloop']",
      "a[class*='bloop']",
      "button[id*='bloop']",
      "a[id*='bloop']",
      "iframe[src*='bloop']"
    ];

    const seen = new Set();
    const matches = [];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (root.contains(node) || !isVisible(node) || seen.has(node)) return;
        seen.add(node);
        matches.push(node);
      });
    });

    getTextLaunchers(root).forEach((node) => {
      if (!seen.has(node)) {
        seen.add(node);
        matches.push(node);
      }
    });

    return matches;
  }

  function triggerLauncher(node) {
    if (node instanceof HTMLAnchorElement || node instanceof HTMLButtonElement) {
      node.click();
      return true;
    }

    if (node instanceof HTMLElement) {
      node.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true }));
      return true;
    }

    return false;
  }

  function init(root) {
    const launchButton = root.querySelector("[data-bloop-launch]");
    const status = root.querySelector("[data-bloop-launch-status]");

    if (!(launchButton instanceof HTMLElement) || !(status instanceof HTMLElement)) return;

    launchButton.addEventListener("click", (event) => {
      const launcher = getBloopLaunchers(root).find((node) => !(node instanceof HTMLIFrameElement));
      const fallbackHref =
        launchButton.dataset.fallbackHref ||
        (launchButton instanceof HTMLAnchorElement ? launchButton.href : root.dataset.loginUrl || "");

      event.preventDefault();

      if (!launcher) {
        openFallback(fallbackHref);
        return;
      }

      status.textContent = "Opening the referral flow...";

      window.requestAnimationFrame(() => {
        const opened = triggerLauncher(launcher);

        if (!opened) {
          openFallback(fallbackHref);
        }
      });
    });
  }

  function boot(scope) {
    const roots = [];
    if (scope instanceof HTMLElement && scope.matches("[data-bloop-referral-page]")) {
      roots.push(scope);
    }
    scope.querySelectorAll?.("[data-bloop-referral-page]").forEach((node) => roots.push(node));
    roots.forEach((node) => init(node));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => boot(document));
  } else {
    boot(document);
  }
})();
